import { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import CustomButton from "../../components/customButton";
import { useNavigate } from "react-router-dom";
import { joinUrlWithParamsId } from "../../helpers/joinParam";
import Loader from "../../components/loader";
import { FaArrowLeft } from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { showAllOrderQuotaton } from "../../lib/apis";
import { scrollToTop } from "../../lib/utils";

const ListQuotation = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  // eslint-disable-next-line
  const [underlineWidth, setUnderlineWidth] = useState(0);
  // eslint-disable-next-line
  const [underlineOffset, setUnderlineOffset] = useState(0);
  const token = localStorage.getItem("token");
  const [ordersShow, setOrdersShow] = useState([])
  const [loading, setLoading] = useState(true);


  const navRefs = useRef<(HTMLDivElement | null)[]>([]);
  const navigate = useNavigate();
  const userId = localStorage.getItem("user");

  useEffect(() => {
    scrollToTop()
  }, [])

  // eslint-disable-next-line
  const handleNavClick = (index: any) => {
    setActiveIndex(index);
  };

  const getAllQuotation = async () => {
    try {
      const { data } = await axios.get(`${showAllOrderQuotaton}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      console.log("mes commandes", data.response.length)
      // setOrders(data.response.reverse().filter((item: any) => { return (item.status != "pretes pour le transport" && item.status != "livrees") }))
      // setOrdersShow(data.response.filter((item: any) => item.quotation_id !== null))
      setOrdersShow(data.response.reverse().filter((item: any) => { return (item.status !== "pretes pour le transport" && item.status !== "livrees") }))
      console.log("mes quotation", data.response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getAllQuotation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentNavRef = navRefs.current[activeIndex];
    if (currentNavRef) {
      setUnderlineWidth(currentNavRef.offsetWidth);
      setUnderlineOffset(currentNavRef.offsetLeft);
    }
  }, [activeIndex]);

  console.log("userId", userId);

  if (loading)
    return (
      <div className="">
        <Loader />
      </div>
    );

  // Composant pour la carte mobile
  const MobileQuotationCard = ({ quotation }: any) => (
    <div className="bg-white p-4 mb-4 rounded-lg shadow border border-gray-100">
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="w-[45%]">
          <p className="text-xs text-gray-500">{t('listQuotation.dateDemande')}</p>
          <p>{new Date(quotation.created_at).toLocaleDateString()}</p>
        </div>
        <div className="w-[45%]">
          <p className="text-xs text-gray-500">{t('listQuotation.livraisonA')}</p>
          <p>{quotation.destination}</p>
        </div>
        <div className="w-[45%]">
          <p className="text-xs text-gray-500">{t('listQuotation.noCommande')}</p>
          <p>Order #{quotation.order_id}</p>
        </div>
        <div className="w-[45%]">
          <p className="text-xs text-gray-500">{t('listQuotation.statut')}</p>
          <p>{quotation.status}</p>
        </div>
      </div>
      <CustomButton
        rounded
        className="bg-green-500 w-full py-2"
        onClick={() => navigate(joinUrlWithParamsId("/details_quaotation/:id", quotation.quotation_id), { state: quotation })}
      >
        <span className="text-white text-sm">{t('listQuotation.detail')}</span>
      </CustomButton>
    </div>
  );

  return (
    <div className="w-full">
      <div className="flex mt-10 md:mt-10 flex-row  items-center justify-start w-full ml-5">

        <Breadcrumb />
      </div>
      {/* Quotation List */}
      <div className="px-5 py-5">
        <h2 className="font-normal text-[23px]">
          {t('listQuotation.titre', { count: ordersShow.length })}
        </h2>
        {/* Version mobile - Cartes */}
        <div className="sm:hidden space-y-3">
          {ordersShow.map((quotation: any) => (
            <MobileQuotationCard key={quotation.quotation_id} quotation={quotation} />
          ))}
        </div>

        <div className=" hidden sm:block overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="bg-softGrey">
                <th className="p-3 text-left">{t('listQuotation.dateDemande')}</th>
                {/* <th className="p-3 text-left">{t('listQuotation.livraisonA')}</th> */}
                <th className="p-3 text-left">{t('listQuotation.noCommande')}</th>
                {/* <th className="p-3 text-left">{t('listQuotation.depart')}</th>
                <th className="p-3 text-left">{t('listQuotation.delai')}</th>
                <th className="p-3 text-left">{t('listQuotation.dateDepart')}</th>
                <th className="p-3 text-left">{t('listQuotation.dateArrivee')}</th> */}
                <th className="p-3 text-left">{t('listQuotation.statut')}</th>
                <th className="p-3 text-left">{t('listQuotation.detail')}</th>
              </tr>
            </thead>
            <tbody>
              {ordersShow.map((quotation: any) => (
                <tr key={quotation.quotation_id} className="border-b">
                  <td className="p-3">
                    {new Date(quotation.created_at).toLocaleDateString()}
                  </td>
                  {/* <td className="p-3">{quotation.destination}</td> */}
                  <td className="p-3">Order #{quotation.order_id}</td>
                  {/* <td className="p-3">{quotation.depart}</td>
                  <td className="p-3">{quotation.delai}</td>
                  <td className="p-3">
                    {new Date(
                      quotation.latest_departure_date
                    ).toLocaleDateString()}
                  </td>
                  <td className="p-3">
                    {new Date(
                      quotation.latest_arrival_date
                    ).toLocaleDateString()}
                  </td> */}
                  <td className="p-3">{quotation.status}</td>
                  <td className="p-3">
                    <CustomButton
                      rounded
                      className="bg-green-500 max-w-[120px] px-3 py-2 h-[25px]"
                    >
                      <span
                        className="text-[13px] text-white"
                        onClick={() =>
                          navigate(
                            joinUrlWithParamsId(
                              "/details_quaotation/:id",
                              quotation.quotation_id
                            ),
                            {
                              state: quotation
                            }
                          )
                        }
                      >
                        {t('listQuotation.detail')}
                      </span>
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListQuotation;